import type {
  DeleteCallOffAttachmentMutationOptions,
  DeleteCallOffAttachmentVariables,
} from './types';

import { useMutation } from '@tanstack/react-query';

import { deleteCallOffAttachment } from './deleteCallOffAttachment';

/**
 * Custom hook for deleting a call-off attachment.
 *
 * @param options - Additional options for the mutation.
 * @returns An object containing the mutation function and related properties.
 *
 * @see https://app.dev.vestigas.com/redoc#tag/Call-Off/operation/delete_attachment_calloffs__calloff_id__attachments__att_id__delete
 */
export const useMutationDeleteCallOffAttachment = (
  options?: DeleteCallOffAttachmentMutationOptions,
) =>
  useMutation({
    mutationFn: async ({
      callOffId,
      attachmentId,
    }: DeleteCallOffAttachmentVariables) =>
      deleteCallOffAttachment(callOffId, attachmentId),
    ...options,
  });
